export const getIncidentStepId = '14a30989-cc13-52b1-9911-d7f421660ec1';

export const isGetIncidentStep = step =>
  (step?.id ?? step?.uuid) === getIncidentStepId;
